import { useTranslations } from "next-intl";
import { ButtonLoadingIcon } from "@/components/common/buttons/button-loading-icon";
import { Button } from "@/components/ui/button";
import { useMobile } from "@/lib/hooks/use-mobile";
import { cn } from "@/lib/utils";

export const AddDiscountFormButton = ({
  submitted,
  isError,
  pending,
  className,
}: {
  submitted: boolean;
  isError?: boolean;
  pending?: boolean;
  className?: string;
}) => {
  const t = useTranslations();
  const { isMobile } = useMobile();

  const buttonLabel = submitted
    ? isMobile
      ? t("discounts.remove")
      : t("cart.removeDiscount")
    : isMobile
      ? t("discounts.add")
      : t("cart.addDiscount");

  return (
    <Button
      className={cn(
        "flex h-14 w-[138px] shrink-0 items-center justify-center rounded-xl",
        className,
      )}
      disabled={!isError && pending}
      size="sm"
      type="submit"
      variant={submitted ? "destructive" : "secondary"}
    >
      {pending ? (
        <ButtonLoadingIcon className="m-0 h-4 w-4 p-0" loading={pending} />
      ) : (
        buttonLabel
      )}
    </Button>
  );
};
